const assets = {
  payPayLogo: "/paypay_logo.png",
  heroImage: "/jashindp/hero_image.png",
};

export default assets;
